/* eslint-disable no-nested-ternary */
import { useRef, useState, useEffect } from 'react';
import { PATH_VEHICLES } from 'routes/paths';
import { Container, Icon, Stack } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import queryString from 'query-string';
import PermissionGuard from 'guards/PermissionGuard';
import useAuth from 'hooks/useAuth';
import _ from 'lodash';
import Page from 'components/Page';
// import { PATH_STORE, PATH_B2B_PARTNERS } from 'routes/paths';
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { useSnackbar } from 'notistack';
import {
  addSellvehicleApi,
  getBuySellVehicleByvehilceIdApi,
  updateSellVehicleApi,
  uploadVehicleImagesApi,
  vehicleExistanceCheckApi
} from 'redux/vehicle/vehicleApi';
import { MIconButton } from 'components/@material-extend';
import closeFill from '@iconify/icons-eva/close-fill';
import {
  classifyBasedOnVehicleType,
  fitnessCertificate,
  registrationTypeSellModule,
  vehicleCheckList,
  vehicleGearType
} from 'utils/constants/vehicle';
import { getStoreByStoreIdApi } from 'redux/stores/storeApi';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import VehicleForm from './components/VehilceForm';

export default function CreateOrUpdateVehicle(props) {
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [checkVehicleExistence, setCheckVehicleExistence] = useState(true);
  const [loading, setLoading] = useState(false);
  const [docs, setDocs] = useState({});
  const formRef = useRef();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [formData, setFormData] = useState([]);
  const dispatch = useDispatch();
  const { user = {} } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const locationQuery = window.location.search;
  const queryValues = queryString.parse(locationQuery);
  const isEdit = location?.pathname?.includes('edit');
  const [valueExits, setValueExits] = useState({
    gear: false,
    kmsdriven: false,
    expectedPrice: false,
    registrationType: false,
    storeId: false
  });
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (isEdit) {
      setCheckVehicleExistence(false);
      setIsButtonDisabled(false);
    }
  }, []);

  useEffect(() => {
    if (!checkVehicleExistence) {
      const { length } = Object.keys(docs);
      if (
        valueExits.gear &&
        valueExits.kmsdriven &&
        valueExits.expectedPrice &&
        valueExits.registrationType &&
        valueExits.storeId &&
        length >= 2
      ) {
        setIsButtonDisabled(false);
      } else {
        setIsButtonDisabled(true);
      }
    }
  }, [checkVehicleExistence, valueExits, docs]);

  const { vehicleDetail = {} } = useSelector(({ vehicleReducer }) => vehicleReducer);

  const onBtFormSubmit = async () => {
    setLoading(true);
    await formRef?.current?.submitForm();
    const formValidationRes = await formRef?.current?.validateForm();
    if (_.isEmpty(formValidationRes)) {
      const values = formRef?.current?.values;
      if (checkVehicleExistence) {
        try {
          const resultAction = await dispatch(vehicleExistanceCheckApi({ vehicleNumber: values.rc_number }));
          const data = unwrapResult(resultAction); // This will throw if the response was rejected

          setLoading(false);
          if (data.isPresent) {
            setLoading(false);
            setIsErrorMessage(true);
            setErrorMessage(data.message);
            // enqueueSnackbar(data.message || 'Vehicle already onboarded for sell purpose', {
            //   variant: 'error',
            //   action: (key) => (
            //     <MIconButton size="small" onClick={() => closeSnackbar(key)}>
            //       <Icon icon={closeFill} />
            //     </MIconButton>
            //   )
            // });
            setIsButtonDisabled(true);
          } else {
            setIsButtonDisabled(true);
            setLoading(false);
            setCheckVehicleExistence(false);
            // Merging the new fields into the existing data
            const updatedData = {
              ...data,
              brandName: values.brandName?.catalogName,
              vehiclesClassify: values.vehiclesClassify,
              vehicleType: values.vehicleType
            };
            // Setting the formData state
            setFormData(updatedData);
            setDocs({});
          }
        } catch (err) {
          setLoading(false);
          setIsErrorMessage(true);
          setErrorMessage('Vehicle number is not registered yet. Please check vehicle number');
          // enqueueSnackbar('Vehicle number is not registered yet. Please check vehicle number', {
          //   variant: 'error',
          //   action: (key) => (
          //     <MIconButton size="small" onClick={() => closeSnackbar(key)}>
          //       <Icon icon={closeFill} />
          //     </MIconButton>
          //   )
          // });
          console.log('Error checking vehicle existence:', err);
        }
      } else {
        let res;
        if (!_.isEmpty(values.storeId)) {
          res = await dispatch(getStoreByStoreIdApi({ storeId: values.storeId }));
          res = unwrapResult(res);
        }
        const checkVehicle = isEdit ? values.vehicleType : values.vehicleType.catalogName;
        const vehicleCheckValue = _.filter(vehicleCheckList, (vehicle) => vehicle.name === checkVehicle);
        let reqBody = {};
        reqBody = {
          userType: 'PARTNER',
          isOwner: true,
          isDealer: true,
          isAuthorised: true,
          hpLoan: !_.isEmpty(values.financer),
          insuranceExperience: values.insurance_upto,
          storeDetails: !_.isEmpty(values.storeId) ? res : '',
          description: values.description,
          purchasedPrice: values?.purchasedPrice,

          // for filtering
          gearType: values.gear.value,
          fuelType: values?.fuel_type,
          regType: values?.registrationType.value || values?.registrationType,
          vehType: vehicleCheckValue[0]?.value,
          brandName: values?.brandName,
          expectedPrice: values?.expectedPrice,
          vehicleCategory: values?.vehiclesClassify.value,
          location: {
            type: 'Point',
            coordinates: [
              res?.contactInfo?.geoLocation?.coordinates?.[0],
              res?.contactInfo?.geoLocation?.coordinates[1]
            ]
          },

          vehicleInfo: {
            vehicleType: vehicleCheckValue[0]?.value,
            vehicleNumber: values?.rc_number,
            brand: values?.maker_description,
            modelName: _.toUpper(values?.maker_model),
            fuelType: values?.fuel_type,
            manufactureYear: moment(values?.manufacturing_date_formatted).format('YYYY'),
            gearType: values?.gear.value,
            kmsDriven: values?.kmsdriven,
            ownership: values?.owner_number,
            color: values?.color,
            bodyType: values?.body_type,
            fitnessCertificate: values?.fitnessCertificate.value || 'false',
            registrationType: values?.registrationType?.value || values?.registrationType,
            expectedPrice: values?.expectedPrice,
            noOfSeats: values?.seat_capacity,
            purpose: 'BUY_SELL'
          }
        };
        if (
          !isEdit &&
          ((user?.role === 'EMPLOYEE' && user?.oemId !== 'SERVICEPLUG') ||
            (user?.role === 'EMPLOYEE' && user?.oemId === 'SERVICEPLUG'))
        ) {
          reqBody.oemUserName = user?.oemId ? user?.oemId : '';
        }
        if (!isEdit && user?.role === 'EMPLOYEE') {
          reqBody.employeeId = user?.userName;
        } else if (user?.role === 'ADMIN' || user?.role === 'OEM') {
          reqBody.employeeId = values?.employeeId;
        }
        if (!isEdit && (user?.role === 'ADMIN' || user?.role === 'OEM')) {
          reqBody.oemUserName = user?.userName;
        }
        if (isEdit) {
          reqBody.vehicleId = vehicleDetail?.vehicleId;
          reqBody._id = vehicleDetail?._id;
          reqBody.purpose = vehicleDetail?.purpose;
        }
        try {
          let createNewVehicle = await dispatch(isEdit ? updateSellVehicleApi(reqBody) : addSellvehicleApi(reqBody));
          createNewVehicle = await unwrapResult(createNewVehicle);
          if (!_.isEmpty(docs)) {
            const formData = new FormData();
            formData.append('vehicleId', createNewVehicle.vehicleId);
            const isFileToUpload = _.some(docs, (value, key) => value?.uploadFile);
            if (isFileToUpload) {
              _.map(docs, (value, key) => value?.uploadFile && formData.append('files', value?.uploadFile));
              const fileUploadRes = await dispatch(uploadVehicleImagesApi(formData));
              unwrapResult(fileUploadRes);
            }
          }
          setLoading(false);
          enqueueSnackbar(`Vehilce ${isEdit ? 'Updated' : 'Created'} Successfully`, { variant: 'success' });
          navigate(PATH_VEHICLES.root);
        } catch (err) {
          setLoading(false);
          console.log(err);
        }
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      let res = await dispatch(getBuySellVehicleByvehilceIdApi({ vehicleId: queryValues?.vehicleId }));
      res = unwrapResult(res);
    };
    if (isEdit) {
      fetchData();
    }
  }, [isEdit]);

  useEffect(() => {
    if (!_.isEmpty(vehicleDetail) && isEdit) {
      const vehicleCheckValue = _.filter(
        vehicleCheckList,
        (vehicle) => vehicle.value === vehicleDetail?.vehicleInfo?.vehicleType
      );
      const vehicleCheckClassify = _.filter(
        classifyBasedOnVehicleType,
        (option) => option.label === vehicleDetail?.vehicleCategory
      );
      const vehicleCheckGearType = _.filter(
        vehicleGearType,
        (option) => option.value === vehicleDetail?.vehicleInfo?.gearType
      );
      const vehicleCheckRegistration = _.filter(
        registrationTypeSellModule,
        (option) => option.value === vehicleDetail?.vehicleInfo?.registrationType
      );
      const vehicleCheckFitnessCertificate = _.filter(
        fitnessCertificate,
        (option) => option.value === vehicleDetail?.vehicleInfo?.fitnessCertificate
      );

      const updatedData = {
        vehicleType: vehicleCheckValue[0]?.name,
        brandName: vehicleDetail?.brandName,
        vehiclesClassify: vehicleCheckClassify[0],
        rc_number: vehicleDetail?.vehicleInfo?.vehicleNumber,
        storeId: vehicleDetail?.storeDetails?.storeId,
        maker_description: vehicleDetail?.vehicleInfo?.brand,
        maker_model: vehicleDetail?.vehicleInfo?.modelName,
        manufacturing_date: vehicleDetail?.vehicleInfo?.manufactureYear,
        owner_number: vehicleDetail?.vehicleInfo?.ownership,
        gear: vehicleCheckGearType[0],
        insurance_upto: vehicleDetail?.insuranceExperience,
        kmsdriven: vehicleDetail?.vehicleInfo?.kmsDriven,
        fuel_type: vehicleDetail?.vehicleInfo?.fuelType,
        expectedPrice: vehicleDetail?.expectedPrice,
        registrationType: vehicleCheckRegistration[0],
        color: vehicleDetail?.vehicleInfo?.color,
        body_type: vehicleDetail?.vehicleInfo?.bodyType,
        seat_capacity: vehicleDetail?.vehicleInfo?.noOfSeats,
        financer: !!vehicleDetail?.hpLoan,
        fitnessCertificate: vehicleCheckFitnessCertificate[0],
        description: vehicleDetail?.description,
        employeeId: vehicleDetail?.employeeId,
        purchasedPrice: vehicleDetail?.purchasedPrice
      };
      setFormData(updatedData);
      setDocs({
        frontView: { file: { preview: vehicleDetail?.vehicleInfo?.vehicleImageList?.frontView?.docURL } },
        rightView: { file: { preview: vehicleDetail?.vehicleInfo?.vehicleImageList?.rightView?.docURL } },
        backView: { file: { preview: vehicleDetail?.vehicleInfo?.vehicleImageList?.backView?.docURL } },
        leftView: { file: { preview: vehicleDetail?.vehicleInfo?.vehicleImageList?.leftView?.docURL } },
        odometer: { file: { preview: vehicleDetail?.vehicleInfo?.vehicleImageList?.odometer?.docURL } },
        seatView: { file: { preview: vehicleDetail?.vehicleInfo?.vehicleImageList?.seatView?.docURL } }
      });
      setValueExits({
        gear: true,
        kmsdriven: true,
        expectedPrice: true,
        registrationType: true,
        storeId: true
      });
    } else if (!isEdit) {
      setFormData([]);
    }
  }, [vehicleDetail]);

  return (
    <>
      {((!isEdit && user?.accessList?.VEHICLES_BUY_SELL?.CREATE) ||
        (isEdit && user?.accessList?.VEHICLES_BUY_SELL?.UPDATE)) && (
        <Page title="Create a new Vehicle | Serviceplug">
          <Container maxWidth="lg" sx={{ mt: '25px', px: '8px !important' }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={0}>
              <HeaderBreadcrumbs
                heading={!isEdit ? 'Create a new Vehicle' : 'Edit Vehicle'}
                // heading="Create a new Vehicle"
                links={[
                  { name: 'Vehicles', href: PATH_VEHICLES },
                  {
                    name: !isEdit ? 'Create' : 'Edit'
                    // href: PATH_STORE.create
                  }
                  // { name: !isEdit ? 'Create One' : consignId }
                ]}
              />

              <LoadingButton
                variant="contained"
                onClick={onBtFormSubmit}
                loadingPosition="start"
                disabled={isButtonDisabled}
                //   startIcon={<SaveIcon />}
                loading={loading}
              >
                {/* {isEdit ? 'Update' : 'Save'} */}
                {checkVehicleExistence ? 'Submit' : isEdit ? 'Update' : 'Save'}
              </LoadingButton>
            </Stack>
            <VehicleForm
              isEdit={isEdit}
              formRef={formRef}
              formData={formData}
              docs={docs}
              setDocs={setDocs}
              setIsButtonDisabled={setIsButtonDisabled}
              checkVehicleExistence={checkVehicleExistence}
              setValueExits={setValueExits}
              isErrorMessage={isErrorMessage}
              setIsErrorMessage={setIsErrorMessage}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
            />
          </Container>
        </Page>
      )}
      {((!isEdit && !user?.accessList?.VEHICLES_BUY_SELL?.CREATE) ||
        (isEdit && !user?.accessList?.VEHICLES_BUY_SELL?.UPDATE)) && <PermissionGuard />}
    </>
  );
}
